// GENERATED by scripts/build-icons.mjs from icons/power.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Power = createIcon('power', [
  ['path', { d: "M12 2v10" }],
  ['path', { d: "M18.4 6.6a9 9 0 1 1-12.77.04" }],
])
